// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('de', {
  defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
  type: {
    email:        "Die Eingabe muss eine gÃ¼ltige E-Mail-Adresse sein.",
    url:          "Die Eingabe muss eine gÃ¼ltige URL sein.",
    number:       "Die Eingabe muss eine Zahl sein.",
    integer:      "Die Eingabe muss eine Zahl sein.",
    digits:       "Die Eingabe darf nur Ziffern enthalten.",
    alphanum:     "Die Eingabe muss alphanumerisch sein."
  },
  notblank:       "Die Eingabe darf nicht leer sein.",
  required:       "Dies ist ein Pflichtfeld.",
  pattern:        "Die Eingabe scheint ungÃ¼ltig zu sein.",
  min:            "Die Eingabe muss grÃ¶Ãer oder gleich %s sein.",
  max:            "Die Eingabe muss kleiner oder gleich %s sein.",
  range:          "Die Eingabe muss zwischen %s und %s liegen.",
  minlength:      "Die Eingabe ist zu kurz. Es mÃ¼ssen mindestens %s Zeichen eingegeben werden.",
  maxlength:      "Die Eingabe ist zu lang. Es dÃ¼rfen hÃ¶chstens %s Zeichen eingegeben werden.",
  length:         "Die LÃ¤nge der Eingabe ist ungÃ¼ltig. Es mÃ¼ssen zwischen %s und %s Zeichen eingegeben werden.",
  mincheck:       "WÃ¤hlen Sie mindestens %s Angaben aus.",
  maxcheck:       "WÃ¤hlen Sie maximal %s Angaben aus.",
  check:          "WÃ¤hlen Sie zwischen %s und %s Angaben.",
  equalto:        "Dieses Feld muss dem anderen entsprechen."
});

Parsley.setLocale('de');
